module.exports = __webpack_public_path__ + "static/media/ChartSize.8654de4b.png";